import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ConfirmProvider } from './contexts/ConfirmContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { SetPasswordPage } from './pages/SetPasswordPage';
import { Dashboard } from './pages/Dashboard';
import { ClientDashboard } from './pages/ClientDashboard';
import { ClientPlanView } from './pages/ClientPlanView';
import { ClientPanelPage } from './pages/ClientPanelPage';
import { WorkoutPlayerPage } from './pages/WorkoutPlayerPage';
import { WorkoutJournalPage } from './pages/WorkoutJournalPage';
import { WeeklyReportPage } from './pages/WeeklyReportPage';
import { ClientPage } from './pages/ClientPage';
import { HealthInterviewPage } from './pages/HealthInterviewPage';
import { ExerciseLibraryPage } from './pages/ExerciseLibraryPage';
import { MonitoringPage } from './pages/MonitoringPage';
import { PlanBuilderPage } from './pages/PlanBuilderPage';
import { ExcelImportPage } from './pages/ExcelImportPage';
import { AIReportPage } from './pages/AIReportPage';
import { FMSPage } from './pages/FMSPage';
import { PackagesPage } from './pages/PackagesPage';
import { CalendarPage } from './pages/CalendarPage';
import { RevenuePage } from './pages/RevenuePage';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ConfirmProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/ustaw-haslo" element={<SetPasswordPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client-dashboard"
            element={
              <ProtectedRoute>
                <ClientDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client-panel"
            element={
              <ProtectedRoute>
                <ClientPanelPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client-plan/:planId"
            element={
              <ProtectedRoute>
                <ClientPlanView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client-plan/:planId/trening/:day"
            element={
              <ProtectedRoute>
                <WorkoutPlayerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client-plan/:planId/dziennik/:day"
            element={
              <ProtectedRoute>
                <WorkoutJournalPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/:id"
            element={
              <ProtectedRoute>
                <ClientPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/:id/health-interview"
            element={
              <ProtectedRoute>
                <HealthInterviewPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/:id/monitoring"
            element={
              <ProtectedRoute>
                <MonitoringPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/:id/packages"
            element={
              <ProtectedRoute>
                <PackagesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/:id/plan-builder"
            element={
              <ProtectedRoute>
                <PlanBuilderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/:id/plan-builder/import"
            element={
              <ProtectedRoute>
                <ExcelImportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/:id/plan-builder/:planId"
            element={
              <ProtectedRoute>
                <PlanBuilderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/:id/ai-report"
            element={
              <ProtectedRoute>
                <AIReportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/:id/fms"
            element={
              <ProtectedRoute>
                <FMSPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/exercises"
            element={
              <ProtectedRoute>
                <ExerciseLibraryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/calendar"
            element={
              <ProtectedRoute>
                <CalendarPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/finanse"
            element={
              <ProtectedRoute>
                <RevenuePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/raport"
            element={
              <ProtectedRoute>
                <WeeklyReportPage />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
        </ConfirmProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
